import React, { createContext, useContext, useState, useEffect } from 'react';
import { authAPI } from '../lib/api';

const AuthContext = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const token = localStorage.getItem('mlx_token');
    const savedUser = localStorage.getItem('mlx_user');
    if (token && savedUser) {
      try {
        setUser(JSON.parse(savedUser));
      } catch (e) {
        localStorage.removeItem('mlx_token');
        localStorage.removeItem('mlx_user');
      }
    }
    setLoading(false);
  }, []);

  const login = async (email, password, mfaCode) => {
    const res = await authAPI.login(email, password, mfaCode);
    const { token, user: userData } = res.data;
    localStorage.setItem('mlx_token', token);
    localStorage.setItem('mlx_user', JSON.stringify(userData));
    setUser(userData);
    return userData;
  };

  const logout = () => {
    localStorage.removeItem('mlx_token');
    localStorage.removeItem('mlx_user');
    setUser(null);
  };

  // Fonction pour définir l'utilisateur (utilisée par OAuth)
  const setAuthUser = (userData) => {
    localStorage.setItem('mlx_user', JSON.stringify(userData));
    setUser(userData);
  };

  return (
    <AuthContext.Provider value={{ user, setUser: setAuthUser, login, logout, loading }}>
      {children}
    </AuthContext.Provider>
  );
}

export const useAuth = () => useContext(AuthContext);
